import { getActionTypes } from '../../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('factorsManagement')([
  'SET_LOADER',
  'SET_FORM_LOADER',
  'LOAD_FACTORS',
  'UPSERT_FACTOR',
  'DELETE_FACTOR',
  'SET_ACTIVE_MODEL',
  'SET_ALL_MODELS',
  'SET_EDIT_VALUES',
  'CLEAR_EDIT_VALUES',
  'SET_SEARCH_VALUE',
  'SET_STEPPER_ENABLED',
]);

// Action creators
export function loadFactors(factors) {
  return { type: types.LOAD_FACTORS, factors };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertFactor(factor) {
  return { type: types.UPSERT_FACTOR, factor };
}

export function deleteFactor(factor) {
  return { type: types.DELETE_FACTOR, factorId: factor.id };
}

export function setActiveModel(model) {
  return { type: types.SET_ACTIVE_MODEL, model };
}

export function setAllModels(models) {
  return { type: types.SET_ALL_MODELS, models };
}

export function setEditValues(editValues) {
  return { type: types.SET_EDIT_VALUES, editValues };
}

export function clearEditValues() {
  return { type: types.CLEAR_EDIT_VALUES };
}

export function setSearchValue(searchValue) {
  return { type: types.SET_SEARCH_VALUE, searchValue };
}

export function setStepperEnabled(enabled) {
  return { type: types.SET_STEPPER_ENABLED, enabled };
}

// Initial state
const initialState = {
  isFactorsPageLoading: true,
  isFactorsFormLoading: false,
  factors: [],
  activeModel: null,
  allModels: [],
  editValues: null,
  searchValue: '',
  isStepperEnabled: false,
  filteredFactors: [],
};

// Reducer
export default function factorsReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isFactorsPageLoading: action.loader };
    }
    
    case types.SET_FORM_LOADER: {
      return { ...state, isFactorsFormLoading: action.loader };
    }
    
    case types.LOAD_FACTORS: {
      return { 
        ...state, 
        factors: action.factors,
        filteredFactors: action.factors
      };
    }
    
    case types.UPSERT_FACTOR: {
      const { factor } = action;
      const updatedFactors = [
        ...state.factors.filter(({ id: factorId }) => factorId !== factor.id), 
        factor
      ];
      return {
        ...state,
        factors: updatedFactors,
        filteredFactors: state.searchValue 
          ? updatedFactors.filter(f => 
              f.name?.toLowerCase().includes(state.searchValue.toLowerCase()) ||
              f.description?.toLowerCase().includes(state.searchValue.toLowerCase())
            )
          : updatedFactors
      };
    }
    
    case types.DELETE_FACTOR: {
      const updatedFactors = state.factors.filter(({ id: factorId }) => factorId !== action.factorId);
      return {
        ...state,
        factors: updatedFactors,
        filteredFactors: state.searchValue 
          ? updatedFactors.filter(f => 
              f.name?.toLowerCase().includes(state.searchValue.toLowerCase()) ||
              f.description?.toLowerCase().includes(state.searchValue.toLowerCase())
            )
          : updatedFactors
      };
    }
    
    case types.SET_ACTIVE_MODEL: {
      return { ...state, activeModel: action.model };
    }
    
    case types.SET_ALL_MODELS: {
      return { ...state, allModels: action.models };
    }
    
    case types.SET_EDIT_VALUES: {
      return { ...state, editValues: action.editValues };
    }
    
    case types.CLEAR_EDIT_VALUES: {
      return { ...state, editValues: null };
    }
    
    case types.SET_SEARCH_VALUE: {
      const filteredFactors = action.searchValue
        ? state.factors.filter(factor =>
            factor.name?.toLowerCase().includes(action.searchValue.toLowerCase()) ||
            factor.description?.toLowerCase().includes(action.searchValue.toLowerCase())
          )
        : state.factors;
        
      return { 
        ...state, 
        searchValue: action.searchValue,
        filteredFactors
      };
    }
    
    case types.SET_STEPPER_ENABLED: {
      return { ...state, isStepperEnabled: action.enabled };
    }
    
    default:
      return state;
  }
}

// Selectors
export const getFactorsLoadingState = (state) => state.factorsReducer.isFactorsPageLoading;
export const getFactorsFormLoadingState = (state) => state.factorsReducer.isFactorsFormLoading;
export const getAllFactors = (state) => state.factorsReducer.factors;
export const getFilteredFactors = (state) => state.factorsReducer.filteredFactors;
export const getActiveModel = (state) => state.factorsReducer.activeModel;
export const getAllModels = (state) => state.factorsReducer.allModels;
export const getEditValues = (state) => state.factorsReducer.editValues;
export const getSearchValue = (state) => state.factorsReducer.searchValue;
export const getStepperEnabled = (state) => state.factorsReducer.isStepperEnabled;
